<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p style="text-indent:0em !important"><span dir="rtl">شكر وعرفان إلى أستاذي ومعلِّمي رأفت الطراونة، الذي كان معي في كلِّ حرف وكلمة مِن هذه الرواية، ولَم يتوانَ لحظة واحدة عن تقديم الاقتراحات وتنقيح العبارات، لك منِّي باقة مِن التقدير والامتنان.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?8a8cc0b8